
(function() {
  var result = { translations: { "bg": { "i18n": { "duration": { "seconds": "{{ seconds }} \u0441\u0435\u043A", "minutes": "{{ minutes }} \u043C\u0438\u043D", "hours": "{{ hours }} \u0447", "hoursAndMinutes": "{{ hours }} \u0447 {{ minutes }} \u043C\u0438\u043D", "days": "{{ days }} \u0434\u043D\u0438", "shortForm": { "seconds": "{{ seconds }} \u0441\u0435\u043A", "minutes": "{{ minutes }} \u043C\u0438\u043D", "hours": "{{ hours }} \u0447", "days": "{{ days }} \u0434", "hoursAndMinutes": "{{ hours }} \u0447 {{ minutes }} \u043C\u0438\u043D" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \u0432\u044A\u0442\u0440. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "bg": "static-7.943"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.943",
    "ar-eg": "static-7.943",
    "bg": "static-7.943",
    "bn": "static-7.943",
    "ca-es": "static-7.943",
    "cs": "static-7.943",
    "da": "static-7.943",
    "de": "static-7.943",
    "el": "static-7.943",
    "en-gb": "static-7.943",
    "en": "static-7.943",
    "es-mx": "static-7.943",
    "es": "static-7.943",
    "fi": "static-7.943",
    "fr-ca": "static-7.943",
    "fr": "static-7.943",
    "he-il": "static-7.943",
    "hr": "static-7.943",
    "hu": "static-7.943",
    "id": "static-7.943",
    "it": "static-7.943",
    "ja": "static-7.943",
    "ko": "static-7.943",
    "lt": "static-7.943",
    "ms": "static-7.943",
    "nl": "static-7.943",
    "no": "static-7.943",
    "pl": "static-7.943",
    "pt-br": "static-7.943",
    "pt-pt": "static-7.943",
    "ro": "static-7.943",
    "ru": "static-7.943",
    "sk": "static-7.943",
    "sl": "static-7.943",
    "sv": "static-7.943",
    "th": "static-7.943",
    "tl": "static-7.943",
    "tr": "static-7.943",
    "uk": "static-7.943",
    "vi": "static-7.943",
    "x-pseudo": "static-7.943",
    "zh-cn": "static-7.943",
    "zh-hk": "static-7.943",
    "zh-tw": "static-7.943"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:bg', {version: 'static-7.943'}); }
})();


